const toggleSubMenuClass = (element, toggle) => {
  const parentElem = element.closest('.menu__item');
  parentElem.classList.toggle('is-open-submenu', toggle);
  document.body.classList.toggle('is-submenu-visible', toggle);
  document.body.classList.remove('submenu-hidden');
  toggleBodyScrollLock(toggle);
};

attachEvent('.menu__item.has-sub-menu .menu__link.level-1', 'click', (ev) => {
  ev.preventDefault();
  toggleSubMenuClass(ev.target, true);
});

attachEvent('.menu__back-btn, .menu__dropdown-close', 'click', (ev) => {
  toggleSubMenuClass(ev.target, false);
  document.body.classList.add('submenu-hidden');
  ev.preventDefault();
});

// Close Modal on ESC key press
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.menu__item').forEach((ele) => {
      ele.classList.remove('is-open-submenu');
      document.body.classList.remove('is-submenu-visible');
      document.body.classList.add('submenu-hidden');
      toggleBodyScrollLock(false);
    });
  }
});
